import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import {
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link,
} from "suneditor/src/plugins";

import { getsubslist } from "../actions/admin";
import { isEmpty } from "../lib/isEmpty";
import { sendNewsLetter } from "../actions/admin";
import toast from "react-hot-toast";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const initialFormValue = {
  subscribedId: [],
  message: "",
};

function Newsletter() {
  const [oldPw, setOldPw] = useState(false);
  const [newPw, setNewPw] = useState(false);
  const [confirmPw, setConfirmPw] = useState(false);
  const [value, setValue] = useState("");

  const [formvalue, setFormvalue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});
  const [content, setcontent] = useState({});
  // const options = [
  //   { value: true, label: "Active" },
  //   { value: false, label: "InActive" },
  // ];

  const [options, setOptions] = useState();
  const [selectedOptions, setSelectedOptions] = useState([]);

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => {
      return {
        ...styles,
        backgroundColor: isHovered
          ? "#00ddeb"
          : isSelected
            ? "#00ddeb"
            : isFocused
              ? "#00ddeb"
              : "#000",
        cursor: "pointer",
        color: isHovered
          ? "#000"
          : isSelected
            ? "#000"
            : isFocused
              ? "#000"
              : "#fff",
        fontSize: "13px",
        zIndex: 1,
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "43px",
      padding: "0px 10px",

      backgroundColor: "transparent",
      color: "red",
      border: "none",
      borderRadius: 0,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "transparent",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "red",
      padding: "0px",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#ffffff",
    }),
    menuList: (base) => ({
      ...base,

      padding: 0,
      width: "100%",

      borderRadius: 5,
      background: "transparent",
    }),

    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#fff",
      };
    },
  };

  const editorOptions = {
    showPathLabel: false,
    minHeight: "200px",
    maxHeight: "400px",
    placeholder: "Enter your text here!!!",
    plugins: [
      align,
      font,
      fontColor,
      fontSize,
      formatBlock,
      hiliteColor,
      horizontalRule,
      lineHeight,
      list,
      paragraphStyle,
      template,
      textStyle,
      image,
      link,
    ],
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["paragraphStyle"],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      ["fontColor", "hiliteColor"],
      ["removeFormat"],
      "/", // Line break
      ["outdent", "indent"],
      ["align", "horizontalRule", "list", "lineHeight"],
      ["link", "image"],
    ],
    formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
    font: [
      "Arial",
      "Calibri",
      "Comic Sans",
      "Courier",
      "Garamond",
      "Georgia",
      "Impact",
      "Lucida Console",
      "Palatino Linotype",
      "Segoe UI",
      "Tahoma",
      "Times New Roman",
      "Trebuchet MS",
    ],
  };

  const getNewsList = async () => {
    let { status, message, data } = await getsubslist();
    console.log(
      "🚀 ~ getNewsList ~ status, message, data :",
      status,
      message,
      data
    );
    if (status) {
      setOptions(data);
      setSelectedOptions([{ label: "All", value: "*" }, ...data]);
    } else {
      setOptions(data);
    }
  };

  useEffect(() => {
    getNewsList();
  }, []);

  const handleSubscriber = async (selectedOption) => {
    try {
      setErrors({});
      let formData = { ...formvalue };
      if (selectedOption && selectedOption?.length > 0) {
        formData["subscribedId"] = selectedOption.map((el) => {
          return el.value;
        });
      } else {
        formData["subscribedId"] = [];
      }
      setFormvalue(formData);
      if (!isEmpty(selectedOption)) {
        setErrors({});
      }
    } catch (err) {
      console.log(err, "handleSubscriber__err");
    }
  };

  const handleEditorChange = async (e) => {
    console.log("🚀 ~ handleEditorChange ~ e:", e);
    try {
      setErrors({});
      setcontent(e);
    } catch (err) {
      console.log(err, "handleEditorChange___err");
    }
  };

  const validation = async (data) => {
    try {
      var errors = {};
      if (isEmpty(data.subscribedId)) {
        errors["subscribed"] = "email   shouldn't be empty";
      }
      if (isEmpty(data.message)) {
        errors["message"] = "message shouldn't be empty";
      }

      return errors;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleSubmit = async () => {
    try {
      let userValue = [];
      selectedOptions.length > 0 &&
        selectedOptions.map((val, index) => {
          if (val.value != "*") {
            userValue.push(val.value);
          }
        });

      let reqData = {
        subscribedId: userValue,
        message: content,
      };
      // let validateError = validation(reqData)
      // if (isEmpty(validateError)) {
      const { status, message } = await sendNewsLetter(reqData);
      if (status == true) {
        toast.success(message);
        setTimeout(() => {
          window.location.reload();
          setFormvalue(initialFormValue);
        }, 2000);
      } else {
        toast.error(message);
        setTimeout(() => {
          window.location.reload();
          setFormvalue(initialFormValue);
        }, 2000);
      }
      // } else {
      //   return false
      // }
    } catch (err) { }
  };

  function getDropdownButtonLabel({ placeholderButtonLabel, value }) {
    if (value && value.some((o) => o.value === "*")) {
      return `${placeholderButtonLabel}: All`;
    } else {
      return `${placeholderButtonLabel}: ${value.length} selected`;
    }
  }

  function onChange(value, event) {
    if (event.action === "select-option" && event.option.value === "*") {
      this.setState(this.options);
    } else if (
      event.action === "deselect-option" &&
      event.option.value === "*"
    ) {
      this.setState([]);
    } else if (event.action === "deselect-option") {
      this.setState(value.filter((o) => o.value !== "*"));
    } else if (value.length === this.options.length - 1) {
      this.setState(this.options);
    } else {
      this.setState(value);
    }
  }

  // const options111 = [
  //   { label: 'Thing 1', value: 1},
  //   { label: 'Thing 2', value: 2},
  //   { label: 'Thing 3', value: 3},
  //   { label: 'Thing 4', value: 4},
  //   { label: 'Thing 5', value: 5},
  //   { label: 'Thing 6', value: 6},
  //   { label: 'Thing 7', value: 7},
  //   { label: 'Thing 8', value: 8},
  // ];

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#121212",
      border: "1px solid #ccc",
      borderRadius: "5px",
      padding: "5px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#4caf50" : state.isFocused ? "#c8e6c9" : "#fff",
      color: state.isSelected ? "#fff" : "#000",
      padding: "10px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 5, // Ensures dropdown appears above other elements
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#d1e7dd",
      borderRadius: "3px",
      color: "#155724",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#155724",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#155724",
      ":hover": {
        backgroundColor: "#f8d7da",
        color: "#721c24",
      },
    }),
  };

  return (
    <>
      <Container fluid className="common_bg position-relative newsletter">
        <div className="liner"></div>

        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>

          <Col xl={10} lg={12}>
            <Header title={"Newsletter"} />
            <div className="mt-5 profile_holder mb-4">
              <Row>
                <Col lg={12} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Email</p>
                    <div className="rp_input_holder rounded-2 email_select">
                      <div className="react_multiSelectParent">
                        {options && (
                          <ReactMultiSelectCheckboxes
                            options={[{ label: "All", value: "*" }, ...options]}
                            // options={[{ label: "All", value: "*" }, ...options111]}
                            placeholderButtonLabel="Subscribers"
                            getDropdownButtonLabel={getDropdownButtonLabel}
                            value={selectedOptions}
                            onChange={onChange}
                            setState={setSelectedOptions}
                            // styles={stylesgraybg}
                            classNamePrefix="react_multiSelect"
                            className="react_multiSelectttt"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={12} className="mb-4">
                  <div className="rp_singleinput_holder">
                    <p className="rp_label mb-2">Message</p>
                    <div className="custom_sunEditor">
                      <SunEditor
                        autoFocus={true}
                        lang="en"
                        className=""
                        setOptions={editorOptions}
                        onChange={(e) => handleEditorChange(e)}
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              <button
                className="orange_small_primary"
                onClick={() => handleSubmit()}
              >
                Submit
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Newsletter;
